import BaseContainer from "@base/container/BaseContainer";
import * as PIXI from "pixi.js";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";

import {Signals} from "@/Imports";
import TweenMax, {TweenLite} from "gsap";
import PlaneAnimationContainer from "@/containers/PlaneAnimationContainer";
import Facade from "@/Facade";
import Linear from "gsap";

export default class DangerousAnimationBgContainer extends BaseContainer {

  constructor(data) {
    super(data)
    this.init()
  }

  init() {

    this.container = new PIXI.Container()
    this.addChild(this.container)
    this.container.visible = false

    this.addElements()

    Signals.roundStart.add(this.start, this)

    Signals.stopFeature.add(this.stop, this)
    Signals.roundEnd.add(this.stop, this)
  }

  addElements() {
    this.enemy = new SpineAnimation('enemyShip')
    this.container.addChild(this.enemy)
    this.enemy.position.set(1800, 250)
    this.enemy.scale.set(0.4)

    this.explosion = new SpineAnimation('ExplosionAnim')
    this.container.addChild(this.explosion)

    this.plane = new PlaneAnimationContainer()
    this.container.addChild(this.plane)
    this.plane.scale.set(0.4)
    this.plane.position.set(-100, 250)
    this.plane.setState(PlaneAnimationContainer.StateJetEngineOff)

  }

  start() {
    this.container.visible = true
    this.plane.visible = false
    this.enemy.visible = false
    this.explosion.visible = false

    this.refreshExplosion = setInterval(() => {
      this.showExplosion()
    }, 3000)

    this.refreshEnemy = setInterval(() => {
      this.showPlaneAndEnemy()
    }, 4000)
  }

  showExplosion() {
    if (Facade.state !== 'flight')
      return

    let x = 400 + Math.random() * 1000
    let y = Math.random() * 300
    this.explosion.visible = true
    this.explosion.position.set(x, y)
    this.explosion.scale.set(0.2 + (y/700))
    this.explosion.start(['ExplosionBattleJet'], [false])

    TweenMax.to(this.explosion, 1.5, { x: '-=500', ease: Linear.none })
  }

  showPlaneAndEnemy() {
    if (!this.plane.visible) {
      this.plane.visible = true
      this.plane.position.set(-100, Math.random() * 300)
      TweenMax.to(this.plane, 4 + Math.random() * 3, {
        x: 2000, onComplete: () => {
          this.plane.visible = false
        }
      })
    }

    if (!this.enemy.visible) {
      this.enemy.visible = true
      this.enemy.angle = -10
      this.enemy.position.set(1800, Math.random() * 300)
      this.enemy.start(['forward', 'idle'], [false, true])
      TweenMax.to(this.enemy, 4 + Math.random() * 6, {
        x: -200, onComplete: () => {
          this.enemy.visible = false
        }
      })
    }
  }

  stop() {
    this.container.visible = false
    TweenMax.killTweensOf(this.plane)
    TweenMax.killTweensOf(this.enemy)
    clearInterval(this.refreshExplosion);
    clearInterval(this.refreshEnemy);
  }
}
